module.exports = __webpack_public_path__ + "static/media/clap.2edf0135.jpg";